import React from "react";
import * as PropTypes from "prop-types";
import Divider from "@material-ui/core/Divider";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

const DownloadMenu = props => (
  <Menu
    anchorEl={props.anchorElement}
    open={props.open}
    onClose={props.onClose}
  >
    {props.onDownloadCsv && (
      <MenuItem onClick={props.onDownloadCsv}>Download as CSV</MenuItem>
    )}

    {props.onDownloadPng && <Divider />}

    {props.onDownloadPng && (
      <MenuItem onClick={props.onDownloadPng}>Download as PNG</MenuItem>
    )}
  </Menu>
);

DownloadMenu.propTypes = {
  anchorElement: PropTypes.object,
  open: PropTypes.bool,
  onDownloadCsv: PropTypes.func,
  onDownloadPng: PropTypes.func,
  onClose: PropTypes.func.isRequired
};

DownloadMenu.defaultProps = {
  open: false
};

export default DownloadMenu;
